import { sortBy } from 'lodash';

import { ReduxThunkType } from '../../types/ReduxThunkType';
import { Actions as BarrierActions } from './actions';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import BarrierService from '../../services/BarrierService';
import { BarrierFormData, BarrierLogType } from './types';

export const getBarriers = (): ReduxThunkType<void> => async (dispatch) => {
  try {
    dispatch(BarrierActions.getBarriers());
    const response = await BarrierService.getBarriers();
    dispatch(BarrierActions.getBarriersSuccess(sortBy(response.data.content, ['serialNumber'])));
  } catch (error) {
    dispatch(BarrierActions.getBarriersError(error as RestErrorResponse));
  }
};

export const createNewBarrier =
  (data: BarrierFormData): ReduxThunkType<Promise<boolean>> =>
  async (dispatch) => {
    try {
      dispatch(BarrierActions.createNewBarrier());
      const response = await BarrierService.createNewBarrier(data);
      dispatch(BarrierActions.createNewBarrierSuccess());
      if (response.data.result.outputMessage === 'DeviceWithSameSerialNumberAlreadyExists') {
        return Promise.resolve(false);
      }
    } catch (error) {
      dispatch(BarrierActions.createNewBarrierError(error as RestErrorResponse));
    }
    return Promise.resolve(true);
  };

export const editBarrierDevice =
  (barrierId: number, data: BarrierFormData): ReduxThunkType<Promise<boolean>> =>
  async (dispatch) => {
    try {
      dispatch(BarrierActions.editBarrierDevice());
      const response = await BarrierService.editBarierDevice(barrierId, data);
      if (response.data.result.outputMessage === 'DeviceAssignedToDeliveryZone') {
        return Promise.resolve(false);
      }
      dispatch(BarrierActions.editBarrierDeviceSuccess());
    } catch (error) {
      dispatch(BarrierActions.editBarrierDeviceError(error as RestErrorResponse));
    }
    return Promise.resolve(true);
  };

export const deleteBarrierDevice =
  (barrierId: number): ReduxThunkType<Promise<boolean>> =>
  async (dispatch) => {
    try {
      dispatch(BarrierActions.deleteBarrierDevice());
      const response = await BarrierService.deleteBarrierDevice(barrierId);
      if (response.data.result.outputMessage === 'CannotDeleteLinkedDevice') {
        return Promise.resolve(false);
      }
      dispatch(BarrierActions.deleteBarrierDeviceSuccess());
    } catch (error) {
      dispatch(BarrierActions.deleteBarrierDeviceError(error as RestErrorResponse));
    }
    return Promise.resolve(true);
  };

export const getBarrier =
  (barrierId: number): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(BarrierActions.getBarrier());
      const response = await BarrierService.getBarrier(barrierId);
      dispatch(BarrierActions.getBarrierSuccess(response.data.content));
    } catch (error) {
      dispatch(BarrierActions.getBarrierError(error as RestErrorResponse));
    }
  };

export const getBarrierLogs =
  (barrierId: number, startTime: string, endTime: string, typeFilter: BarrierLogType | string): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(BarrierActions.getBarrierLogs());
      const response = await BarrierService.getBarrierLogs(barrierId, startTime, endTime, typeFilter);
      dispatch(BarrierActions.getBarrierLogsSuccess(response.data.content));
    } catch (error) {
      dispatch(BarrierActions.getBarrierLogsError(error as RestErrorResponse));
    }
  };
